import React from 'react'
import VehicleForm from './VehicleForm'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { useLocation } from 'react-router'

function VehicleEdit(props) {
    const { notify } = props
    const { state } = useLocation()
    return (
        <VehicleForm isInEdit editData={state} notify={notify} />
    )
}

VehicleEdit.propTypes = {
    notify: PropTypes.func,
}

VehicleEdit.defaulProps = {
    notify: noop,
}

function mapStateToProps() {
    return {}
}
export default connect(mapStateToProps)(VehicleEdit)